export default __webpack_public_path__ + "svg/calendar/2025/8/octubre.svg?c8a7c190";